import { useEffect, useState } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";

function useMatch(query: string) {
  const [matches, setMatches] = useState(false);
  useEffect(() => {
    const media = window.matchMedia(query);
    const apply = () => setMatches(media.matches);
    apply();
    media.addEventListener("change", apply);
    return () => media.removeEventListener("change", apply);
  }, [query]);
  return matches;
}

function useOnAppSurface() {
  const [onApp, setOnApp] = useState(false);
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => setOnApp(root.dataset.surface === "app");
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(root, { attributes: true, attributeFilter: ["data-surface"] });
    return () => observer.disconnect();
  }, []);
  return onApp;
}

/** App-only toast placement. Marketing pages keep the shared Sonner defaults. */
export function AppToaster() {
  const onApp = useOnAppSurface();
  const wide = useMatch("(min-width: 768px)");
  if (!onApp) return <Sonner />;
  return (
    <Sonner
      position={wide ? "bottom-right" : "bottom-center"}
      offset={wide ? 16 : { bottom: "calc(4rem + env(safe-area-inset-bottom) + 0.75rem)" }}
      closeButton
    />
  );
}
